import { render, staticRenderFns } from "./crm-create.vue?vue&type=template&id=6cc19d4f&"
import script from "./crm-create.vue?vue&type=script&lang=js&"
export * from "./crm-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports